import type { Point } from 'geojson';
import type { MapProps } from '../Map/Map.types';

export interface NearbyCamerasProps {
    cameras: Camera[];
    region: string;
    currentArea: string;
    currentRoad: string;
    noImageUrl?: string;
    animateTiles?: boolean;
}

export class Camera {
    cameraId: string;
    imageUrl: string;
    name: string;
    road: string;
    wgs84Position: Point;
    isFavorite: boolean;
    isCurrent: boolean;
    area: string;
    url: string;
    pageId: number;
    thumbUrl?: string;
    roadUrl?: string;
    sortIndex?: number;
    hasFullSizePhoto?: boolean;
}

export interface ICameraMenuProps {
    cameras: Camera[];
    currentCameraPageId: number;
    currentArea: string;
    currentRoad: string;
    currentRegion: string;
    allCamerasPageUrl: string;
    favoriteCamerasPageUrl: string;
}

export interface ICameraMenuState {
    openItem: string;
    menuItems: MenuItem[];
    mobileopen?: boolean;
}

export interface ICameraMenuGroupProps {
    groups: CameraGroup[];
    currentRegion: string;
    currentArea: string;
    currentRoad: string;
}

export interface ICameraMenuGroupState {
    groupnameopen: string;
}

export interface ICameraMenuListProps {
    cameras: Camera[];
    currentRegion: string;
    currentArea: string;
    currentRoad: string;
}

export interface CameraFavoriteTogglerProps {
    pageId: number;
    region: string;
}

export interface NearByCamerasByCameraProps {
    cameras: Camera[];
    currentCameraPageId: number;
    region: string;
    isfavorite: boolean;
    currentArea: string;
    currentRoad: string;
    noImageUrl?: string;
}

export interface NearByCamerasByCameraState {
    closeCameras: Camera[];
}

export interface CameraImageProps {
    id: number;
    imageUrl: string;
    updateTime?: number;
    title: string;
    noImageUrl?: string;
    onUpdate?(updateTime: Date): void;
    hasFullSizePhoto?: boolean;
    showExpandButton?: boolean;
}

export class CameraGroup {
    key: string;
    type: string;
    cameras: Camera[];
    url: string;
    hidden: boolean;

    constructor(key: string, type: string, cameras: Camera[], url: string, hidden?: boolean) {
        this.key = key;
        this.type = type;
        this.cameras = cameras;
        this.url = url;
        this.hidden = hidden === true;
    }
}

export class MenuItem {
    icon: string;
    name: string;
    cameraGroups: CameraGroup[];
    url?: string;

    constructor(icon: string, name: string, cameraGroups?: CameraGroup[], url?: string) {
        this.icon = icon;
        this.name = name;
        this.cameraGroups = cameraGroups;
        this.url = url;
    }
}

export interface CameraOverviewProps {
    hideThumbnailList: boolean;
    region: string;
    cameras: Camera[];
    currentArea: string;
    currentRoad: string;
    favoritesPage: boolean;
    time: Date;
    pageAlias: string;
    mapSettings: MapProps;
    missingFavoriteCameraText: string;
    noImageUrl?: string;
    pageId: string;
}

export interface ICameraOverviewState {
    visibleCameras: Camera[];
    showMap: boolean;
}

export interface CameraInfoProps {
    cameraPageId: number;
    region: string;
    showUpdateTime?: boolean;
    updatedTime: Date;
}

export interface CameraWrapperProps {
    className?: string;
    pageId: number;
    imageUrl: string;
    name?: string;
    noImageUrl?: string;
    url?: string;
    region: string;
    showUpdateTime?: boolean;
    hasFullSizePhoto?: boolean;
    showExpandButton?: boolean;
}

export interface CameraWrapperState {
    cameraUpdateTime: Date;
}
